<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import type { ComboboxTriggerProps } from 'reka-ui'
import { reactiveOmit } from '@vueuse/core'
import { ComboboxTrigger, useForwardProps } from 'reka-ui'
import { cn } from '@ds/lib/utils'

/*
 * The chevron end of the field. Registry ships it unstyled with a hardcoded
 * `tabindex="0"`, which would put a second tab stop inside a control the input
 * already owns — dropped.
 */
const props = defineProps<ComboboxTriggerProps & { class?: HTMLAttributes['class'] }>()

const delegatedProps = reactiveOmit(props, 'class')

const forwarded = useForwardProps(delegatedProps)
</script>

<template>
  <ComboboxTrigger
    v-bind="forwarded"
    :class="cn(
      'inline-flex shrink-0 items-center justify-center text-muted-foreground cursor-pointer',
      'transition-transform duration-ds-fast ease-ds-standard',
      'focus:outline-none disabled:cursor-not-allowed',
      props.class,
    )"
  >
    <slot />
  </ComboboxTrigger>
</template>
